import { Controller } from "@hotwired/stimulus"

// Countdown timer that shows time remaining until expiry
// Usage: <span data-controller="countdown" data-countdown-expires-at-value="2026-03-29T10:00:00Z">
export default class extends Controller {
  static values = { expiresAt: String }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  update() {
    const expiresAt = new Date(this.expiresAtValue)
    const now = new Date()
    const diff = expiresAt - now

    if (diff <= 0) {
      this.element.textContent = "Expirada"
      this.element.classList.add("text-red-500")
      clearInterval(this.timer)
      return
    }

    const hours = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    const pad = (n) => String(n).padStart(2, "0")
    this.element.textContent = `Expira em: ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`
  }
}
